export enum ComponentId {
  PERPETRATOR_COMPANY_NAME = "name",
  PERPETRATOR_COMPANY_REGON = "regon",
  PERPETRATOR_COMPANY_PHONE = "phone",
  PERPETRATOR_COMPANY_EMAIL = "email",
  PERPETRATOR_COMPANY_STREET = "street",
  PERPETRATOR_COMPANY_STREET_2 = "street2",
  PERPETRATOR_COMPANY_ZIP_CODE_PL = "zipCodePL",
  PERPETRATOR_COMPANY_ZIP_CODE_GENERIC = "zipCodeGeneric",
  PERPETRATOR_COMPANY_CITY = "city",
  PERPETRATOR_COMPANY_COUNTRY = "country",
  PERPETRATOR_COMPANY_PROVINCE = "province",
  PERPETRATOR_COMPANY_OC_NUMBER = "ocNumber",
  PERPETRATOR_COMPANY_INSURANCE_COMPANY = "insuranceCompany",
}
